module.exports = __webpack_public_path__ + "img/right_two.03eb865f.svg";